export default class {
	constructor(options) {
		this.defaults = {
			$el: null,
		};
		this.options = {};
		Object.assign(this.options, this.defaults, options);

		this.namespace = "imgRestrictions";
		this.init(true);
	}

	init(bool) {
		if (bool) {
			const imgs = document.querySelectorAll("img");
			if (imgs.length === 0) return;
			imgs.forEach((img) => {
				img.addEventListener("contextmenu", (e) => {
					e.preventDefault();
				});
				img.setAttribute("draggable", false);
				img.style.userSelect = "none";
				img.style.webkitUserDrag = "none";
			});
		}
	}
}
